import * as Carousels from "./carousels";
import * as Posts from "./posts";
import * as PostCast from "./post-cast";
import { lazyWithRetry } from "../../utils/lazy-with-retry";

const Templates = lazyWithRetry(() => import("./templates"), "Templates");
const Write = lazyWithRetry(() => import("./write"), "Write");
const AI = lazyWithRetry(() => import("./ai"), "AI");
const Influencers = lazyWithRetry(() => import("./influencers"), "Influencers");
const PostsForYou = lazyWithRetry(() => import("./posts-for-you"), "PostsForYou");
const Chat = lazyWithRetry(() => import("./chat"), "Chat");
const IdeasGenerator = lazyWithRetry(() => import("./ideas-generator"), "IdeasGenerator");
const SavedIdeas = lazyWithRetry(() => import("./saved-ideas"), "SavedIdeas");
const PostGenerationFromTemplates = lazyWithRetry(
  () => import("./post-generation-from-templates"),
  "PostGenerationFromTemplates"
);
const TemplateEditor = lazyWithRetry(() => import("./template-editor"), "TemplateEditor");
const VoiceNoteToPost = lazyWithRetry(() => import("./voice-notes"), "VoiceNoteToPost");
const InfluencerPosts = lazyWithRetry(() => import("./influencer-posts"), "InfluencerPosts");
const ViralPosts = lazyWithRetry(() => import("./viral-posts"), "ViralPosts");

export {
  Templates,
  Write,
  Posts,
  AI,
  Influencers,
  PostsForYou,
  Chat,
  IdeasGenerator,
  SavedIdeas,
  PostGenerationFromTemplates,
  TemplateEditor,
  VoiceNoteToPost,
  Carousels,
  InfluencerPosts,
  ViralPosts,
  PostCast,
};
